'use strict';

// search_histories に保存する履歴の数
// 1000 ぐらいまで上げても問題はないが、あまり古いデータは使用されないだろうし
// データのロードコストも上がるので 50-100 ぐらいの間が実用的かと
const MAX_SEARCH_HISTRORIES = 100;

const normalizeWord = (word) => {
  if (typeof word !== 'string') {
    // convert to string
    if (word == null) {
      word = '';
    } else {
      try {
        word = word.toString();
      } catch (err) {
        word = '';
      }
    }
  }

  return word.trim();
};

const removeWordFromSearchHistoriesInternal = (histories, word) => {
  if (!histories) {
    return [];
  }
  return histories.filter((s) => s !== '' && s !== word);
};

module.exports = Object.assign(module.exports, {
  MAX_SEARCH_HISTRORIES,

  /**
  remove a word from search histories
  @params {Array<String>} histories
  @params {Any} word
  @return {Array<String>}
  */
  removeWordFromSearchHistories(histories, word) {
    word = normalizeWord(word);
    return removeWordFromSearchHistoriesInternal(histories, word);
  },

  /**
  add a word to search histories
  @params {Array<String>} histories
  @params {Any} word
  @return {Array<String>}
  */
  addWordToSearchHistories(histories, word) {
    word = normalizeWord(word);

    let rv;
    if (word) {
      rv = [word, ...removeWordFromSearchHistoriesInternal(histories, word)];
    } else {
      // copy always
      rv = histories.slice();
    }

    // shrink array size to MAX_SEARCH_HISTRORIES
    rv.length = Math.min(rv.length, MAX_SEARCH_HISTRORIES);
    return rv;
  }
});
